var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"color":"blue","light":"","dense":"","outlined":"","items":_vm.items,"label":"Language"},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})
}
var staticRenderFns = []

export { render, staticRenderFns }